import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {get_AstroSallary_Transaction,get_AstroData} from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';
import Loader from '../Loader/Loader';
import Select from "react-select";
import { customStyles } from '../Utility/Utility';
import * as XLSX from "xlsx";
import swal from "sweetalert";


const AstrologerSalary = () => {
    const dispatch = useDispatch();
    const AstroWalletTransaction = useSelector((state) => state.feedBackReducer.AstroSallaryTransaction);
    
    const total=AstroWalletTransaction?.reduce((acc, item) => acc + parseFloat(item.MonthlySalary), 0);
    const finaltotal=total?.toFixed(2);
  


    const AstroData = useSelector((state) => state.feedBackReducer.AstroData);

    const [filteredData, setFilteredData] = useState([]);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [orderStatus, setOrderStatus] = useState(null);
    const [loading, setloading] = useState(false);
    const [selectedAstro, setSelectedAstro] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;

        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;

        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);

        dispatch(get_AstroSallary_Transaction(formattedToday, formattedToday,selectedAstro.value,setloading));
    }, [dispatch]);

    useEffect(() => {
        dispatch(get_AstroData(isActive));
    }, []);

    useEffect(() => {
        if (AstroData && Array.isArray(AstroData)) {
            const filtered = AstroData.map(({ DisplayName, ID }) => ({
                label: DisplayName,
                value: ID,
            }));
            setFilteredData(filtered);
        }
    }, [AstroData]);



    const handleSearch = (isActive) => {

        const formatDate = (dateTime) => {
            if (!dateTime) return null;
            const date = new Date(dateTime); 
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const formattedStartDate = formatDate(startTime);
        const formattedEndDate = formatDate(endTime);

        const data = {
            FromDate: formattedStartDate,
            Todate: formattedEndDate,
            orderStatus: orderStatus,
        };

        dispatch(get_AstroSallary_Transaction(data.FromDate, data.Todate,selectedAstro.value,setloading));


    };
    const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  const date = new Date(dateTimeStr);

  const day = date.getDate();
  const month = date.getMonth() + 1; 
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};
 
 const handleChange = (option) => {
   
     setSelectedOption(option === 'All' ? null : option);

  };
    const columns = [

       {
  name: 'Astrologer Name',
  selector: (row) => row.AstroName,
  sortable: true,
  
},
 {
  name: 'Astrologer Number',
  selector: (row) => row.AstroMobileNo,
  sortable: true,
  
},


{
  name: 'Amount',
  selector: (row) => row.MonthlySalary,
  sortable: true,
  
}
// ,{
//   name: 'Date',
//   selector: (row) => formatDateTime(row.TransactionDateTime),
//   sortable: true,
//   maxWidth: "180px",
// }

 

    ];





const handleExportToExcel = () => {
  if (!AstroWalletTransaction || AstroWalletTransaction.length === 0) {
    swal("No data available to export!", "", "info");
    return;
  }

  const exportData = AstroWalletTransaction.map((row, index) => ({
    "S.No": index + 1,
    "Astrologer Name": row.AstroName,
    "Mobile No": row.AstroMobileNo,
    "Amount": row.MonthlySalary,
   
  }));
  exportData.push({
    "S.No": "",
    "Astrologer Name": "",
    "Mobile No": "Total Amount",
    
    "Amount": ` ${finaltotal}`,
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Astrologers Salary");

  XLSX.writeFile(workbook, "Astrologers_Salary.xlsx");

  setTimeout(() => {
    swal("Download complete!", "Your astrologers Salary has been saved.", "success");
  }, 1000);
};


    return (
        <div>
         
            <div className="form-group">
<h2 style={{ color: '#f7931e', fontWeight: 700 }}>Astrologers Salary</h2>
                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                    <div  className="col-3">
                        <label className="form-label">Search by Astrologer</label>
                        <Select
                            options={filteredData}
                            value={selectedAstro}
                            onChange={(selectedOption) => setSelectedAstro(selectedOption)}
                            placeholder="Select Astrologer"
                            isSearchable
                           
                        />
                    </div>


                    
                </div>
                <div>
                <button style={{width:"70px"}} className="btn btn-primary m-2" onClick={() => handleSearch(isActive)}>
                    Search
                </button>

<button
  className="btn btn-warning m-2 "
  style={{  fontWeight: 500 }}
  onClick={handleExportToExcel}
>
  Export to Excel
</button>
</div>

            </div>


            <div className="col-12 mt-2">

  {AstroWalletTransaction?.length > 0 && (
          <span
            style={{
              color: "black",
              fontSize: "15px",
              margin: "20px",
              fontWeight: "bold",
            }}
          >
            Total Amount : {finaltotal}
          </span>
        )}

                {loading ? (
                    <Loader />
                ) : (
                    <DataTable
                        dense
                        data={AstroWalletTransaction || []}
                        columns={columns}
                        selectableRowsHighlight
                        pagination
                        persistTableHead={true}
                        noDataComponent={"There are no data to display"}
                           customStyles={customStyles}
                    />)}
            </div>
        </div>
    );
};
export default AstrologerSalary;



